const FileUploadComponentSizes = {
  small: 'small',
  large: 'large'
};
export default FileUploadComponentSizes;